import React, { FC } from 'react'
import { useSelector } from 'react-redux'

import ReactGA from 'react-ga'

import Footer from '../../Footer'

import check from '../../../../assets/img/check.png'

import './styles.scss'
import { Plann3rStore } from '../../../../store/types'

const GifStep: FC = () => {
  ReactGA.event({
    category: 'Onboarding',
    action: 'Step 2',
  })

  const strings = useSelector(
    (state: Plann3rStore) => state.languages.strings.onboarding.gifstep,
  )

  return (
    <div className="onboarding_box">
      <div className="onboarding_content gifstep">
        <div className="imgdiv">
          <img alt="Check" src={check} />
        </div>
        <h2 className="title has-text-centered">{strings.title}</h2>
        <div className="step-description-string">
          {strings.description}
          <br />
          {strings.description_2}
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default GifStep
